<script lang="ts" setup>
    import { ref, onMounted, watch } from 'vue'
    // import axios from '@/utils/apiClient'
    import axios from '@/utils/apiClient'
    import { useCompanyStore } from '@/stores/companyStore'
    const companyStore = useCompanyStore()

    interface Department {
        departmentID: number
        departmentName: string
    }

    interface Position {
        positionID: number
        positionName: string
    }

    interface Company {
        companyID: number
        companyName: string
    }

    interface Employee {
        employeeID: string
        fullName: string
        fullNameKhmer: string
        profilePath: string
        department: Department
        position: Position
        company: Company
    }

    const props = defineProps({
        modelValue: {
            type: Array as () => string[],
            default: () => [],
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'Employees',
        },
        prop: {
            type: String,
            default: null,
        },
    })

    const emit = defineEmits(['update:modelValue'])
    const employees = ref<Employee[]>([])
    const value = ref<string[]>(props.modelValue)
    const loading = ref(false)
    const fetch = async () => {
        try {
            loading.value = true
            const params = {
                companyID: companyStore.companyID,
            }
            const res = await axios.get('Employee/ActiveEmployee', { params })
            employees.value = res.data
        } catch (error) {
            console.error('Error fetching employees:', error)
        } finally {
            loading.value = false
        }
    }

    onMounted(() => {
        fetch()
    })

    watch(
        () => props.modelValue,
        newValue => {
            value.value = newValue
        },
    )

    watch(value, newValue => {
        emit('update:modelValue', newValue)
    })
</script>

<template>
    <el-form-item class="w-100" :label="label" label-position="top" :prop="prop">
        <el-select
            size="large"
            filterable
            multiple
            :loading="loading"
            :loading-text="$t('loading')"
            :disabled="disabled"
            class="w-100"
            v-model="value"
            placeholder="Select Employees"
            :clearable="clearable"
        >
            <el-option
                v-for="employee in employees"
                :key="employee.employeeID"
                :label="employee.fullName"
                :value="employee.employeeID"
            >
                {{ employee.fullName }}
            </el-option>
            <template #prefix>
                <i class="text-primary ti ti-user"></i>
            </template>
        </el-select>
    </el-form-item>
</template>
